<template>
  <div class="flex flex-col items-center gap-4">
    <qrcode-vue :value="signLink" :size="50" level="H" />
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  components: { QrcodeVue },
  props: {
    signLink: {
      type: String,
      required: true,
    },
  },
};
</script>
